import Modal from "react-bootstrap/Modal";
import { CloseIcon } from "./icons";

/**
 * Painel que sobe do rodapé, com os cantos de cima arredondados — o padrão do
 * celular para conteúdo secundário (informações da loja, escolhas rápidas).
 * É o Modal do react-bootstrap com outra cara: foco, Esc e backdrop
 * continuam os dele. O visual está em src/styles/mobile.css (.modal-sheet).
 */
export default function BottomSheet({ show, onHide, title, children }) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      dialogClassName="modal-sheet"
      contentClassName="modal-sheet__content"
      aria-labelledby="bottom-sheet-title"
    >
      <div className="modal-sheet__handle" aria-hidden="true" />
      <div className="modal-sheet__header">
        <h2 id="bottom-sheet-title" className="modal-sheet__title">
          {title}
        </h2>
        <button
          type="button"
          className="icon-button"
          onClick={onHide}
          aria-label="Fechar"
        >
          <CloseIcon />
        </button>
      </div>
      <div className="modal-sheet__body">{children}</div>
    </Modal>
  );
}
